export default __webpack_public_path__ + "b7bfe00ff793ccb62c2b7c1766024b0f.png";